import {
  Avatar,
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Box,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Link,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect, useRef, useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Link as RouterLink } from "react-router-dom";
import { useSnackbar } from "notistack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SyncIcon from "@mui/icons-material/Sync";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import ToshowExercise from "./components/modalToshowExercise";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import ConfirmationWithDescription from "src/components/ModalPopover/ConfirmationWithDescription";
import ParameterModel from "./components/ParameterModel";
import { Icon } from "@iconify/react";
import ExerciseHistoryModel from "./components/ExerciseHistoryModel";
import { programme_workout_exercise_history_list_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { get_root_value } from "src/utils/domUtils";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import PaceCalculator from "src/pages/Calender/component/PaceCalculator";
import EMOMExercisesUI from "./EMOMExercisesUI";
import AMRAPExercisesUI from "./AMRAPExercisesUI";
import SomeThingElseExercisesUI from "./SomeThingElseExercisesUI";
import {
  exercise_history,
  exercise_obj,
  getOptionsByValue,
  is_small_medium_screen,
  multiple_sets,
  paceFromVdot,
  select_obj_exercise,
  super_set_item,
  super_set_item_2,
  getMihr,
  getKmhr,
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getPaceTextinPaces,
  handle_change_parameters,
  formatWithLeadingZeros,
} from "src/utils/constant";
import CustomConfirmationOk from "src/components/ModalPopover/ConfirmationOk";
import { makeStyles, useTheme } from "@mui/styles";
import ModalToShowAnExerciseInfo from "./components/ModalToShowAnExerciseInfo";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import RoundsForTimeExercisesUI from "./RoundsForTimeExercisesUI";
import RepsForTimeExercisesUI from "./RepsForTimeExercisesUI";
import SuperSetUI from "./SuperSetUI";
import { s3baseUrl } from "src/config/config";

const useStyles = makeStyles((theme) => ({
  loading2: {
    position: "absolute",
    top: "50%",
    right: "50%",
    zIndex: 1000,
  },
}));

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};

const WorkoutExercisesUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  isHistory,
  memberId,
  member_vdot,
  member_vdot_info,
  isSidebar,
  isWithHistoryAndBigScreen,
}) => {
  const {
    setUserExerciseHistory,
    setUserExerciseHistoryLoading,
    selectedExercise,
    setSelectedExercise,
  } = useContentSetting();
  const [exerInfo, setExsrInfo] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenForSuperset, setModalOpenForSuperset] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyModalOpenSuperset, setHistoryModalOpenSuperset] =
    useState(false);
  const vdotwholeObject = findPaceObjectByVdot(member_vdot);
  const [historyModalData, setHistoryModalData] = useState([]);

  const [paceModalOpen, setPaceModalOpen] = useState(false);
  const [memberVdotData, setMemberVdotDataData] = useState({
    distance: member_vdot_info?.race_type || "",
    time_interval: parseInt(member_vdot_info?.time_taken) || 0,
    easy_long: "e_km",
    thre_shold: "t_km",
    interval: "i_400_m",
    pace: vdotwholeObject?.e_km_low || 0,
    paceUp: vdotwholeObject?.e_km_up || 0,
    pace1: vdotwholeObject?.t_km || 0,
    pace2: vdotwholeObject?.i_400_m || 0,
  });

  useEffect(() => {
    if (member_vdot) {
      const vdotObject = findPaceObjectByVdot(member_vdot);
      setMemberVdotDataData((prevState) => ({
        ...prevState,
        distance: member_vdot_info?.race_type || prevState.distance,
        time_interval:
          parseInt(member_vdot_info?.time_taken) || prevState.time_interval,
        pace: vdotObject?.e_km_low || 0,
        paceUp: vdotObject?.e_km_up || 0,
        pace1: vdotObject?.t_km || 0,
        pace2: vdotObject?.i_400_m || 0,
      }));
    }
  }, [member_vdot, member_vdot_info]);
  const [superAlterIndex, setSuperAlterIndex] = useState("");
  const [alterChanges, setAlterChanges] = useState("");
  const [toAlterChanges, setToAlterChanges] = useState("");
  const [openExerciseAlter, setOpenExerciseAlter] = useState(false);
  const [openSuperSetAlter, setOpenSuperSetAlter] = useState(false);
  const [openPaceAlert, setOpenPaceAlert] = useState(false);
  const [alterIndex, setalterIndex] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [outerIndex, setOuterIndex] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [isWithHistory, setIsWithHistory] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const [isHoveredExercise, setIsHoveredExercise] = useState("");
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [staticNumber, setStaticNumber] = useState(1);
  const classes = useStyles();

  const handleMouseEnter = (setIndex, exerciseIndex) => {
    setIsHovered(setIndex);
    setIsHoveredExercise(exerciseIndex);
  };

  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleClick = () => {
    setIsEditable(true);
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
    setIsEditable(false);
  };

  const handleMouseLeave = () => {
    const delay = 0;
    timeoutRef.current = setTimeout(() => {
      setIsHovered("");
    }, delay);
  };

  const handleAdd = (i) => {
    let list = addArray;

    list.splice(i + 1, 0, {
      ...exercise_obj(member_vdot, vdotwholeObject),
    });
    setaddArray([...list]);
    setModalChangeExe(true);
    handleScrollCalled(i + 1);
  };

  const handleAddSet = (mainindex, index) => {
    let list = addArray;
    const data = { ...list[mainindex]["set"][index] };
    list[mainindex]["set"].splice(index + 1, 0, data);
    setaddArray([...list]);
    setModalChangeExe(true);
    handleSetScrollCalled(mainindex, index + 1);
  };

  const handleAddMultipleSets = (mainindex, data) => {
    const numberOfSets = parseInt(staticNumber, 10);
    if (isNaN(numberOfSets) || numberOfSets <= 0) {
      enqueueSnackbar("Please enter a valid number greater than 0.", {
        variant: "error",
      });
      return;
    }

    if (numberOfSets > 10) {
      enqueueSnackbar("Please enter a valid number less than 10.", {
        variant: "error",
      });
      return;
    }
    let list = [...addArray];
    const lastSet =
      list[mainindex]["set"].length > 0
        ? list[mainindex]["set"][list[mainindex]["set"].length - 1]
        : {};

    const new_sets = multiple_sets(lastSet, vdotwholeObject, member_vdot);

    for (let i = 0; i < numberOfSets; i++) {
      list[mainindex]["set"].push({ ...new_sets });
    }
    setaddArray(list);
    setModalChangeExe(true);
    setIsEditable(false);
    setStaticNumber(1);
  };

  const handleDeleteSet = (mainindex, index) => {
    let list = addArray;
    list[mainindex]["set"].splice(index, 1);
    setaddArray([...list]);
    setModalChangeExe(true);
  };

  const handleAgreeExercise = (mainindex) => {
    setalterIndex(mainindex);
    setAlterChanges(
      addArray[mainindex + 1].superSet.length
        ? addArray[mainindex + 1].superset_sets
        : addArray[mainindex + 1].set.length,
    );
    setToAlterChanges(
      addArray[mainindex].superSet.length
        ? addArray[mainindex].superSet.length
        : addArray[mainindex].set.length,
    );
    const first = addArray[mainindex].superSet.length
      ? addArray[mainindex].superSet.length
      : addArray[mainindex].set.length;
    const second = addArray[mainindex + 1].superSet.length
      ? addArray[mainindex + 1].superset_sets
      : addArray[mainindex + 1].set.length;

    if (first == second) {
      addSuperSet(mainindex);
    } else {
      setOpenExerciseAlter(true);
    }
  };

  const addAgreeSuperSet = (index) => {
    let current = { ...addArray[alterIndex] };
    current.superSet = [];
    let array = [current];
    if (
      addArray[alterIndex + 1]?.superSet &&
      addArray[alterIndex + 1].superSet.length > 0
    ) {
      addArray[alterIndex + 1].superSet.map((item) => {
        array.push(item);
      });
    } else {
      array.push(addArray[alterIndex + 1]);
    }
    const list = [...addArray];
    list[alterIndex]["superSet"] = array;
    setaddArray(list);
    setModalChangeExe(true);
    let e = {
      target: {
        name: "superset_sets",
        value: addArray[alterIndex].set.length,
      },
    };
    handleChangeSuperSetCount(e, alterIndex);
    handleDelete(alterIndex + 1);
    setOpenExerciseAlter(false);
  };

  const addSuperSet = (index) => {
    let current = { ...addArray[index] };
    current.superSet = [];
    let array = [current];
    if (
      addArray[index + 1]?.superSet &&
      addArray[index + 1].superSet.length > 0
    ) {
      addArray[index + 1].superSet.map((item) => {
        array.push(item);
      });
    } else {
      array.push(addArray[index + 1]);
    }
    const list = [...addArray];
    list[index]["superSet"] = array;
    setaddArray(list);
    setModalChangeExe(true);
    let e = {
      target: {
        name: "superset_sets",
        value: addArray[index].set.length,
      },
    };
    handleChangeSuperSetCount(e, index);
    handleDelete(index + 1);
    setOpenExerciseAlter(false);
  };

  const addAgreeInSuperSet = () => {
    let array = addArray[superAlterIndex].superSet;
    if (addArray[superAlterIndex + 1].superSet.length > 0) {
      addArray[superAlterIndex + 1].superSet.map((item) => {
        array.push(item);
      });
    } else {
      array.push(addArray[superAlterIndex + 1]);
    }
    const list = [...addArray];
    list[superAlterIndex]["superSet"] = array;
    setaddArray(list);
    setModalChangeExe(true);
    let e = {
      target: {
        name: "superset_sets",
        value: list[superAlterIndex].superset_sets,
      },
    };
    handleChangeSuperSetCount(e, superAlterIndex);
    handleDelete(superAlterIndex + 1);
    setOpenSuperSetAlter(false);
  };

  const handleDelete = (i) => {
    const delValue = [...addArray];
    delValue.splice(i, 1);
    setaddArray(delValue);
    setModalChangeExe(true);
  };

  const handleArrow = (value, index) => {
    const list = [...addArray];
    list[index]["open"] = value;
    setaddArray(list);
  };

  const handleChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["set"][index1][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const getVdotPace = (index, index1) => {
    const list = [...addArray];
    if (!list[index]["set"][index1]["vdot"]) {
      return;
    }
    const vodt = list[index]["set"][index1]["vdot"];
    const distanceType = list[index]["set"][index1]["race_type"];
    const paceType = list[index]["set"][index1]["pace_type"];

    const vdot33Object = findPaceObjectByVdot(vodt);
    if (distanceType != "el") {
      list[index]["set"][index1]["pace"] = vdot33Object[paceType];
      if (!vdot33Object[paceType]) {
        memberId && setOpenPaceAlert(true);
      }
    } else {
      list[index]["set"][index1]["pace"] = vdot33Object[paceType + "_low"];
      list[index]["set"][index1]["paceUp"] = vdot33Object[paceType + "_up"];
    }
    setaddArray(list);
  };

  const handleChangeVdotPaceType = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["set"][index1][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
    getVdotPace(index, index1);
  };

  const handleChangeVdotDistance = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index].set[index1][name] = value;
    const optionsTypeSArray = getOptionsByValue(value);
    list[index].set[index1]["optionsType"] = optionsTypeSArray;
    list[index].set[index1]["pace_type"] = optionsTypeSArray[0].key;
    setaddArray(list);
    setModalChangeExe(true);

    if (list[index].parameters.includes("Vdot")) getVdotPace(index, index1);
  };

  const handleChangeTempo = (e, index, index1) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[index]["set"][index1][name] = value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleRearageSetCount = (index, count) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = count;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setaddArray(list);
    setModalChangeExe(true);
    setHistoryModalOpenSuperset(false);
  };

  const handleChangeSuperSetCount = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeUp = (value) => {
    if (value == 0) {
      enqueueSnackbar("You are already on Top !", { variant: "info" });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(value, 1);
    items.splice(value - 1, 0, reorderedItem);
    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleExerciseList = (value, isWithHistory) => {
    setIsExerciseForSuperSet(false);
    setDetailsData(value);
    setOpenDetails(true);
    setIsWithHistory(isWithHistory);
  };

  const handleSelectExercise = (values) => {
    const list = [...addArray];
    if (Array.isArray(values)) {
      const updatedList = list.slice(0, detailsData);
      values.forEach((exercise) => {
        let newExercise = select_obj_exercise(
          member_vdot,
          vdotwholeObject,
          exercise,
        );
        updatedList.push(newExercise);
      });
      const remainingItems = list.slice(detailsData);
      const filteredArray = remainingItems.filter(
        (item) =>
          !(item.type === "general" && Object.keys(item.exercise).length === 0),
      );
      const finalList = [...updatedList, ...filteredArray];
      setaddArray(finalList);
    }
    setModalChangeExe(false);
    if (isWithHistoryAndBigScreen) {
      values.forEach((value, index) => {
        const targetIndex = detailsData + index;
        handleHistoryOFAnExercise(value, targetIndex);
      });
    }
  };

  const handleSelectExerciseSingle = (value) => {
    const list = [...addArray];
    if (list[detailsData]["exercise"]._id == value._id) {
      return;
    }
    list[detailsData]["exercise"] = value;
    list[detailsData]["description"] = value?.instructions;
    list[detailsData]["open"] = true;
    setaddArray(list);
    setModalChangeExe(false);
    if (isWithHistoryAndBigScreen) {
      handleHistoryOFAnExercise(value, detailsData);
    }
  };

  const handleSelectExerciseType = (e, index) => {
    const list = [...addArray];
    list[index]["type"] = e.target.value;
    list[index]["time_interval"] = e.target.value == "emom" ? 60 : 600;
    list[index]["description"] = "";
    setaddArray(list);
    setModalChangeExe(false);
  };

  const handleCopyExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["set"] = value.set;
    list[detailsData]["parameters"] = value?.parameters;
    setaddArray(list);
    setModalChangeExe(true);
    setHistoryModalOpen(false);
  };

  const handleCopySupersetExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["set"] = value.set;
    list[detailsData]["superSet"][exerIndex]["parameters"] = value?.parameters;
    setaddArray(list);
    setModalChangeExe(true);
    handleRearageSetCount(detailsData, list[detailsData].superset_sets);
  };

  const handleSelectSupersetExercise = (values) => {
    const updatedList = values.map((value, index) => {
      const targetSuperset = addArray[detailsData]?.superSet[exerIndex + index];
      if (targetSuperset) {
        if (targetSuperset["exercise"]?._id !== value._id) {
          return {
            ...targetSuperset,
            exercise: value,
            description: value?.instructions || "",
            open: true,
          };
        }
        return targetSuperset;
      }
      return select_obj_exercise(member_vdot, vdotwholeObject, value);
    });

    const newArray = [...addArray];
    const currentSuperSet = [...(newArray[detailsData]?.superSet || [])];
    updatedList.forEach((item, index) => {
      currentSuperSet[exerIndex + index] = item;
    });

    newArray[detailsData] = {
      ...newArray[detailsData],
      superSet: currentSuperSet,
    };

    setaddArray(newArray);
    setModalChangeExe(false);
    if (isWithHistoryAndBigScreen) {
      values.forEach((value, index) => {
        handleHistoryOFAnExerciseSuperset(
          value,
          detailsData,
          exerIndex + index,
        );
      });
    }
  };

  const handleSelectSupersetExerciseSingle = (value) => {
    const list = [...addArray];
    if (list[detailsData]["superSet"][exerIndex]["exercise"]._id == value._id) {
      return;
    }
    list[detailsData]["superSet"][exerIndex]["exercise"] = value;
    list[detailsData]["superSet"][exerIndex]["description"] =
      value?.instructions;
    list[detailsData]["superSet"][exerIndex]["open"] = true;

    setaddArray(list);
    setModalChangeExe(true);
    if (isWithHistoryAndBigScreen) {
      handleHistoryOFAnExerciseSuperset(value, detailsData, exerIndex);
    }
  };

  const handleChangeDown = (value) => {
    if (value >= addArray.length - 1) {
      enqueueSnackbar("You are already on Bottom !", {
        variant: "info",
      });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(value, 1);
    items.splice(value + 1, 0, reorderedItem);

    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleParameters = (value) => {
    setModalOpen(true);
    setModalOpenForSuperset(false);
    setOuterIndex(value);
    setExsrInfo(addArray[value].parameters);
  };

  const handleHistoryOpen = async (value, index) => {
    setDetailsData(index);
    handleHistory(value?.exercise, index);
  };

  const handleHistoryPreviousOpen = async (value) => {
    setSelectedExercise(value?.exercise?._id);
    setUserExerciseHistoryLoading(true);
    setUserExerciseHistory(value?.history);
    setUserExerciseHistoryLoading(false);
  };
  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  const handleHistory = async (value, index) => {
    setDetailsData(index);
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    try {
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        if (!result.exercise_history.length > 0) {
          const list = [...addArray];
          delete list[index]["history"];
          setaddArray(list);
          return;
        }

        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });

        setHistoryModalData(givenExercise);
        const list = [...addArray];
        list[index]["history"] = givenExercise;
        setaddArray(list);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setHistoryModalOpen(true);
    }
  };

  const handleHistoryOFAnExercise = async (value, index) => {
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    try {
      setUserExerciseHistoryLoading(true);
      let result = await programme_workout_exercise_history_list_api(postData);

      if (result.code == 200) {
        setSelectedExercise(value?._id);
        let givenExercise = result.exercise_history.map((item) => {
          if (!result.exercise_history.length > 0) {
            setaddArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[index] = {
                ...updatedArray[index],
                history: givenExercise,
              };
              return updatedArray;
            });

            return;
          }
          return exercise_history(item);
        });
        setUserExerciseHistory(givenExercise);
        setaddArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[index] = {
            ...updatedArray[index],
            history: givenExercise,
          };
          return updatedArray;
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setUserExerciseHistoryLoading(false);
    }
  };

  const handleHistoryOFAnExerciseSuperset = async (
    value,
    mainIndex,
    exerInde,
  ) => {
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    try {
      setUserExerciseHistoryLoading(true);
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        setSelectedExercise(value?._id);
        let givenExercise = result.exercise_history.map((item) => {
          if (!result.exercise_history.length > 0) {
            setaddArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[mainIndex]["superSet"][exerInde]["history"] = [];
              return updatedArray;
            });
            return;
          }

          return exercise_history(item);
        });
        setUserExerciseHistory(givenExercise);
        setaddArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[mainIndex]["superSet"][exerInde]["history"] =
            givenExercise;
          return updatedArray;
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setUserExerciseHistoryLoading(false);
    }
  };

  const handleChangeParametersInsetFieldValueSuperSet = (
    value,
    outerIndex,
    exerIndex,
  ) => {
    const items = Array.from(addArray);

    const sets = handle_change_parameters(
      items,
      items[outerIndex].superSet[exerIndex].parameters,
      items[outerIndex].superSet[exerIndex].set,
    );

    items[outerIndex].superSet[exerIndex].set = sets;
    setaddArray(items);
  };

  const handleChangeParametersInsetFieldValue = (value, outerIndex) => {
    const items = Array.from(addArray);

    const sets = handle_change_parameters(
      items,
      items[outerIndex].parameters,
      items[outerIndex].set,
    );

    items[outerIndex].set = sets;
    setaddArray(items);
  };

  const handleChangeParametersInset = (value) => {
    const items = Array.from(addArray);
    if (modalOpenForSuperset) {
      items[outerIndex].superSet[exerIndex].parameters = value;
      setExsrInfo(items[outerIndex].superSet[exerIndex].parameters);
      setaddArray(items);
      setModalChangeExe(true);
      handleChangeParametersInsetFieldValueSuperSet(
        value,
        outerIndex,
        exerIndex,
      );
      return;
    }
    if (value.includes("Vdot")) {
      items[outerIndex].set = [items[outerIndex].set[0]];
    }
    items[outerIndex].parameters = value;
    setExsrInfo(items[outerIndex].parameters);
    setaddArray(items);
    setModalChangeExe(true);
    handleChangeParametersInsetFieldValue(value, outerIndex);
  };

  const memueOptions = (value) => {
    const MENU_OPTIONS = [];
    MENU_OPTIONS.unshift(
      {
        label: "Move Up",
        icon: "mdi:arrow-up",
        handleClick: handleChangeUp,
        disabled: value == 0 ? true : false,
      },
      {
        label: "Move Down",
        icon: "ic:outline-arrow-downward",
        handleClick: handleChangeDown,
        disabled: value >= addArray.length - 1 ? true : false,
      },
    );

    return MENU_OPTIONS;
  };

  const handleMinutesChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const minutes = parseInt(e.target.value) || 0;
    const seconds = list[index]["set"][index1][name] % 60;
    updateIntervalTime(minutes, seconds, index, index1, name);
  };

  const handleSecondsChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59);
    const minutes = Math.floor(list[index]["set"][index1][name] / 60);
    updateIntervalTime(minutes, seconds, index, index1, name);
  };

  const updateIntervalTime = (minutes, seconds, index, index1, name) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[index]["set"][index1][name] = totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleScrollCalled = (data) => {
    const todayCell = document.querySelector(
      `.exercise-label-box[id="${data}"]`,
    );
    if (todayCell)
      todayCell.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const handleSetScrollCalled = (mainindex, index) => {
    setTimeout(() => {
      const todayCell = document.querySelector(
        `.workout-card-inset[id="${index},${mainindex}"]`,
      );
      if (todayCell)
        todayCell.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  };

  return (
    <div className="w-100">
      {isLoading && (
        <CircularProgress className={classes.loading2} color="primary" />
      )}
      {openPaceAlert && (
        <CustomConfirmationOk
          open={openPaceAlert}
          setOpen={setOpenPaceAlert}
          title="Oops!"
          descriotion="This type & distance not suitable for that pace"
        />
      )}
      {openSuperSetAlter && (
        <ConfirmationWithDescription
          open={openSuperSetAlter}
          setOpen={setOpenSuperSetAlter}
          title={"Are you sure you want to take this action?"}
          descriotion={`You are trying to alternate an exercise with  ${toAlterChanges} sets with an exercise with ${alterChanges} sets. If you proceed, we’ll modify the exercise to have  ${toAlterChanges} sets.`}
          handleAgree={addAgreeInSuperSet}
        />
      )}
      {openExerciseAlter && (
        <ConfirmationWithDescription
          open={openExerciseAlter}
          setOpen={setOpenExerciseAlter}
          title={"Are you sure you want to take this action?"}
          descriotion={`You are trying to alternate an exercise with  ${toAlterChanges} sets with an exercise with ${alterChanges} sets. If you proceed, we’ll modify the exercise to have  ${toAlterChanges} sets.`}
          handleAgree={addAgreeSuperSet}
        />
      )}
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      {openDetails && (
        <ToshowExercise
          open={openDetails}
          setOpen={setOpenDetails}
          handleChange={
            isWithHistory ? handleSelectExerciseSingle : handleSelectExercise
          }
          isWithHistory={isWithHistory}
        />
      )}
      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={
            isWithHistory
              ? handleSelectSupersetExerciseSingle
              : handleSelectSupersetExercise
          }
          isWithHistory={isWithHistory}
        />
      )}
      {modalOpen && (
        <ParameterModel
          open={modalOpen}
          setOpen={setModalOpen}
          data={exerInfo}
          handleChange={handleChangeParametersInset}
          addArray={addArray}
        />
      )}
      {historyModalOpen && (
        <ExerciseHistoryModel
          open={historyModalOpen}
          setOpen={setHistoryModalOpen}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={handleCopyExercise}
          member_vdot={member_vdot}
        />
      )}
      {historyModalOpenSuperset && (
        <ExerciseHistoryModel
          open={historyModalOpenSuperset}
          setOpen={setHistoryModalOpenSuperset}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={handleCopySupersetExercise}
          member_vdot={member_vdot}
        />
      )}
      {paceModalOpen && member_vdot && (
        <Dialog
          open={paceModalOpen}
          onClose={() => setPaceModalOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              backgroundColor: "white",
              color: "black",
              boxShadow: "none",
            },
          }}
        >
          <div className="text-end mt-1 d-flex justify-content-between align-items-center">
            <DialogTitle
              sx={{
                paddingY: 0,
                color: get_root_value("--portal-theme-primary"),
              }}
            >
              Pace Calculator
            </DialogTitle>
            <IconButton
              className="back-screen-button me-1"
              onClick={() => setPaceModalOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent>
            <PaceCalculator
              checkedPace={!!member_vdot}
              memberVdotData={memberVdotData}
              setMemberVdotDataData={setMemberVdotDataData}
              member_vdot={member_vdot}
              member_vdot_info={member_vdot_info}
            />
          </DialogContent>
        </Dialog>
      )}
      <div className="characters">
        {addArray?.map((data, mainindex) => {
          return (
            <>
              {data?.type == "something_else" ? (
                <SomeThingElseExercisesUI
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={setModalChangeExe}
                  isHistory={isHistory}
                  mainindex={mainindex}
                  handleAdd={handleAdd}
                  handleMouseLeave={handleMouseLeave}
                  handleDelete={handleDelete}
                  memueOptions={memueOptions}
                />
              ) : data?.type == "amrap" ? (
                <AMRAPExercisesUI
                  handleAdd={handleAdd}
                  memueOptions={memueOptions}
                  handleDelete={handleDelete}
                  isWithHistoryAndBigScreen={isWithHistoryAndBigScreen}
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={setModalChangeExe}
                  mainindex={mainindex}
                  isHistory={isHistory}
                  memberId={memberId}
                  member_vdot={member_vdot}
                  member_vdot_info={member_vdot_info}
                />
              ) : data?.type == "rounds_for_time" ? (
                <RoundsForTimeExercisesUI
                  handleAdd={handleAdd}
                  memueOptions={memueOptions}
                  handleDelete={handleDelete}
                  isWithHistoryAndBigScreen={isWithHistoryAndBigScreen}
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={setModalChangeExe}
                  mainindex={mainindex}
                  isHistory={isHistory}
                  memberId={memberId}
                  member_vdot={member_vdot}
                  member_vdot_info={member_vdot_info}
                />
              ) : data?.type == "reps_for_time" ? (
                <RepsForTimeExercisesUI
                  handleAdd={handleAdd}
                  memueOptions={memueOptions}
                  handleDelete={handleDelete}
                  isWithHistoryAndBigScreen={isWithHistoryAndBigScreen}
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={setModalChangeExe}
                  mainindex={mainindex}
                  isHistory={isHistory}
                  memberId={memberId}
                  member_vdot={member_vdot}
                  member_vdot_info={member_vdot_info}
                />
              ) : data?.type == "emom" ? (
                <EMOMExercisesUI
                  handleAdd={handleAdd}
                  memueOptions={memueOptions}
                  handleDelete={handleDelete}
                  isWithHistoryAndBigScreen={isWithHistoryAndBigScreen}
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={setModalChangeExe}
                  mainindex={mainindex}
                  isHistory={isHistory}
                  memberId={memberId}
                  member_vdot={member_vdot}
                  member_vdot_info={member_vdot_info}
                />
              ) : data?.superSet && data?.superSet.length > 0 ? (
                <>
                  <SuperSetUI
                    addArray={addArray}
                    setExsrInfo={setExsrInfo}
                    setModalOpen={setModalOpen}
                    setModalOpenForSuperset={setModalOpenForSuperset}
                    setHistoryModalData={setHistoryModalData}
                    setSuperAlterIndex={setSuperAlterIndex}
                    setAlterChanges={setAlterChanges}
                    setToAlterChanges={setToAlterChanges}
                    setOpenSuperSetAlter={setOpenSuperSetAlter}
                    setIsLoading={setIsLoading}
                    setDetailsData={setDetailsData}
                    setExerIndex={setExerIndex}
                    setOuterIndex={setOuterIndex}
                    setIsWithHistory={setIsWithHistory}
                    setIsExerciseForSuperSet={setIsExerciseForSuperSet}
                    setOpenSingleExerciseInfo={setOpenSingleExerciseInfo}
                    setSingleExerciseInfo={setSingleExerciseInfo}
                    handleMouseLeave={handleMouseLeave}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    setHistoryModalOpenSuperset={setHistoryModalOpenSuperset}
                    data={data}
                    mainindex={mainindex}
                    isHistory={isHistory}
                    isWithHistoryAndBigScreen={isWithHistoryAndBigScreen}
                    member_vdot={member_vdot}
                    vdotwholeObject={vdotwholeObject}
                    memberId={memberId}
                    setPaceModalOpen={setPaceModalOpen}
                  />
                </>
              ) : (
                <div
                  style={{
                    width: "100%",
                    padding: "1px",
                    position: "relative",
                  }}
                >
                  <div
                    className=" my-1 workout-set-card w-100"
                    onMouseEnter={() => handleMouseLeave()}
                    style={{
                      width: "100%",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div className=" cross-icon d-flex justify-content-end">
                      <Tooltip title="Remove Exercise">
                        <RemoveCircleOutlineIcon
                          onClick={() => handleDelete(mainindex)}
                          className="diary-icon-remove"
                        />
                      </Tooltip>
                      <Tooltip title="Add Exercise">
                        <AddCircleOutlineIcon
                          onClick={() => handleAdd(mainindex)}
                          className="diary-icon-add"
                        />
                      </Tooltip>

                      <CustomPopoverSection
                        menu={memueOptions(mainindex)}
                        data={mainindex}
                      />
                    </div>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                      }}
                      onMouseEnter={() => handleMouseLeave()}
                    >
                      <div
                        className="row  "
                        onMouseEnter={() => handleMouseLeave()}
                      >
                        <div
                          className={`col-sm-12 ${
                            isHistory ? "col-md-6" : "col-md-7"
                          } col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                        >
                          {data?.is_modified && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-32px",
                                justifyContent: "center",
                                zIndex: "1",
                                left: "-38px",
                                transform: "rotate(-53deg)",
                              }}
                            >
                              <Chip
                                label={"Modified"}
                                variant="contained"
                                color={"error"}
                                sx={{
                                  fontSize: "10px",
                                  height: "auto",
                                  width: "auto",
                                }}
                              />
                            </span>
                          )}
                          <div className="exercise-label-box" id={mainindex}>
                            <span className="outer-label">Exercise</span>
                            <div className="d-flex align-items-center justify-content-between">
                              <div
                                className="exercise-label w-100"
                                onClick={() =>
                                  handleExerciseList(
                                    mainindex,
                                    data?.exercise ? true : false,
                                  )
                                }
                              >
                                <div className="d-flex align-items-center">
                                  {data?.exercise?.image?.thumbnail_3 && (
                                    <Avatar
                                      sx={{ borderRadius: "5px" }}
                                      alt="User Image"
                                      src={
                                        s3baseUrl +
                                        data?.exercise?.image?.thumbnail_3
                                      }
                                    />
                                  )}
                                  <div className="label-text ms-1">
                                    {data?.exercise?.title
                                      ? data?.exercise?.title
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="exercise-action">
                                <div style={{ fontSize: "16px" }}>
                                  {data?.exercise ? (
                                    <div>
                                      <InfoIcon
                                        onClick={() =>
                                          handleClickOpen(data?.exercise?._id)
                                        }
                                        className="d-block"
                                        fontSize="14px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                      <EditIcon
                                        onClick={() =>
                                          handleExerciseList(mainindex, true)
                                        }
                                        fontSize="12px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <AddIcon
                                      onClick={() =>
                                        handleExerciseList(mainindex)
                                      }
                                      sx={{
                                        opacity: 0.5,
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <Button
                            sx={{ textTransform: "inherit" }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="d-flex align-items-center ms-2 small-contained-dialog-button"
                            onClick={() => {
                              handleArrow(
                                !data?.open ? true : false,
                                mainindex,
                              );
                            }}
                          >
                            {!data?.open ? (
                              <KeyboardArrowDownIcon
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            ) : (
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            )}

                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {` Sets ${data?.set?.length}`}
                            </Typography>
                          </Button>
                        </div>
                        <div
                          className={`col-sm-12 ${
                            isHistory ? "col-md-6" : "col-md-5"
                          } col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                        >
                          <div
                            className="d-flex align-items-center ms-3 set-parameters "
                            onClick={() => {
                              handleParameters(mainindex);
                            }}
                          >
                            <Icon icon="pajamas:labels" fontSize="10px" />
                            <Typography variant="body2" sx={{ ml: 0.5 }}>
                              {`Parameters`}
                            </Typography>
                          </div>
                          <div className="d-flex align-items-center ms-3 set-parameters ">
                            <Select
                              id="select-option"
                              variant="outlined"
                              size="small"
                              name="restType"
                              value={data?.type ? data?.type : "general"}
                              label="Weight Type"
                              inputProps={{
                                style: {
                                  padding: 0,
                                },
                              }}
                              onChange={(e) => {
                                handleSelectExerciseType(e, mainindex);
                              }}
                              sx={{
                                "& legend": {
                                  display: "none",
                                },
                                "& fieldset": {
                                  top: 0,
                                },
                                fontSize: "13px",
                                border: "none",
                                "& fieldset": {
                                  border: "none",
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: 0,
                                },
                                "& .MuiInputBase-inputSizeSmall": {
                                  color: `${get_root_value(
                                    "--portal-theme-primary",
                                  )} !important`,
                                },
                              }}
                            >
                              <MenuItem value="general">General</MenuItem>
                              <MenuItem value="emom">EMOM</MenuItem>
                              <MenuItem value="amrap">AMRAP</MenuItem>
                              <MenuItem value="something_else">
                                Something else
                              </MenuItem>
                              <MenuItem value="rounds_for_time">
                                Rounds For Time
                              </MenuItem>
                              <MenuItem value="reps_for_time">
                                Reps For Time
                              </MenuItem>
                            </Select>
                          </div>
                          {!isWithHistoryAndBigScreen &&
                          isHistory &&
                          data?.exercise ? (
                            <>
                              <Button
                                sx={{ textTransform: "inherit" }}
                                size="small"
                                color="primary"
                                variant="contained"
                                className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                onClick={() => {
                                  handleHistoryOpen(data, mainindex);
                                }}
                              >
                                <Icon icon="fa-solid:history" fontSize="10px" />
                                <Typography variant="body2" sx={{ ml: 0.5 }}>
                                  {`History`}
                                </Typography>
                              </Button>

                              {member_vdot && (
                                <Button
                                  sx={{ textTransform: "inherit" }}
                                  size="small"
                                  color="primary"
                                  variant="contained"
                                  className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                  onClick={() => setPaceModalOpen(true)}
                                >
                                  <DirectionsRunIcon
                                    sx={{ fontSize: "14px" }}
                                  />
                                  <Typography variant="body2" sx={{ ml: 0.5 }}>
                                    Pace
                                  </Typography>
                                </Button>
                              )}
                            </>
                          ) : isWithHistoryAndBigScreen &&
                            data?.history &&
                            selectedExercise !== data?.exercise?._id ? (
                            <Button
                              sx={{ textTransform: "inherit" }}
                              size="small"
                              color="primary"
                              variant="contained"
                              className="d-flex align-items-center ms-2 small-contained-dialog-button"
                              onClick={() => {
                                handleHistoryPreviousOpen(data);
                              }}
                            >
                              <Icon icon="fa-solid:history" fontSize="10px" />
                              <Typography variant="body2" sx={{ ml: 0.5 }}>
                                {`History`}
                              </Typography>
                            </Button>
                          ) : (
                            isHistory &&
                            data?.history && (
                              <Button
                                sx={{ textTransform: "inherit" }}
                                size="small"
                                color="primary"
                                variant="outlined"
                              >
                                <Icon icon="fa-solid:history" fontSize="10px" />
                                <Typography variant="body2" sx={{ ml: 0.5 }}>
                                  Viewing History
                                </Typography>
                              </Button>
                            )
                          )}
                        </div>
                      </div>
                      {data?.open && (
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Instructions"
                          label="Instructions"
                          type="number"
                          value={data.description}
                          name="description"
                          multiline
                          rows={2}
                          onChange={(e) => handleChangeDes(e, mainindex)}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: { fontSize: "14px" },
                          }}
                          sx={{
                            borderRadius: "5px",
                            mt: 2,
                            width: "100%",
                          }}
                        />
                      )}
                      {data?.open && (
                        <div className="mt-3 mb-4 d-flex justify-content-end">
                          <div
                            className="input-container"
                            onClick={handleClick}
                          >
                            {isEditable && (
                              <div
                                className="close-icon"
                                onClick={handleCloseClick}
                              >
                                X
                              </div>
                            )}
                            <input
                              type="text"
                              value={
                                isEditable ? staticNumber : "Add Multiple Sets"
                              }
                              readOnly={!isEditable}
                              onChange={(e) => setStaticNumber(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleAddMultipleSets(mainindex, data);
                                }
                              }}
                              placeholder="How many more sets?"
                              className={`input ${
                                isEditable ? "input-active" : "input-readonly"
                              }`}
                            />
                            <span
                              className={`icon ${
                                isEditable ? "icon-moving" : "icon-left"
                              }`}
                              onClick={(e) => {
                                if (isEditable) {
                                  e.stopPropagation();
                                  handleAddMultipleSets(mainindex, data);
                                }
                              }}
                            >
                              +
                            </span>
                          </div>
                        </div>
                      )}
                      {data?.open &&
                        data?.set?.map((item, index1) => (
                          <div
                            className="d-flex align-items-center my-3 workout-card-inset"
                            id={`${index1},${mainindex}`}
                            onMouseEnter={() =>
                              handleMouseEnter(index1, mainindex)
                            }
                          >
                            {is_small_medium_screen() ? (
                              <div>
                                <div
                                  className="icon-calendar-workout-small-screen"
                                  onMouseEnter={() =>
                                    handleMouseEnter(index1, mainindex)
                                  }
                                >
                                  <Tooltip title="Add set">
                                    <AddIcon
                                      className="add-icon-calendar-workout me-1"
                                      onMouseEnter={() =>
                                        handleMouseEnter(index1, mainindex)
                                      }
                                      onClick={() =>
                                        handleAddSet(mainindex, index1)
                                      }
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={`${
                                      data?.set.length > 1
                                        ? "Delete set"
                                        : "Can't be Deleted"
                                    }`}
                                  >
                                    <DeleteIcon
                                      onMouseEnter={() =>
                                        handleMouseEnter(index1, mainindex)
                                      }
                                      className={`${
                                        data?.set.length > 1
                                          ? "del-icon-calendar-workout-working"
                                          : "del-icon-calendar-workout-notwork"
                                      }`}
                                      onClick={
                                        data?.set.length > 1
                                          ? () =>
                                              handleDeleteSet(mainindex, index1)
                                          : () => {}
                                      }
                                    />
                                  </Tooltip>
                                </div>
                              </div>
                            ) : (
                              <div>
                                {isHovered === index1 &&
                                  isHoveredExercise == mainindex && (
                                    <div
                                      className="icon-calendar-workout"
                                      onMouseEnter={() =>
                                        handleMouseEnter(index1, mainindex)
                                      }
                                    >
                                      <Tooltip title="Add set">
                                        <AddIcon
                                          className="add-icon-calendar-workout me-1"
                                          onMouseEnter={() =>
                                            handleMouseEnter(index1, mainindex)
                                          }
                                          onClick={() =>
                                            handleAddSet(mainindex, index1)
                                          }
                                        />
                                      </Tooltip>
                                      <Tooltip
                                        title={`${
                                          data?.set.length > 1
                                            ? "Delete set"
                                            : "Can't be Deleted"
                                        }`}
                                      >
                                        <DeleteIcon
                                          onMouseEnter={() =>
                                            handleMouseEnter(index1, mainindex)
                                          }
                                          className={`${
                                            data?.set.length > 1
                                              ? "del-icon-calendar-workout-working"
                                              : "del-icon-calendar-workout-notwork"
                                          }`}
                                          onClick={
                                            data?.set.length > 1
                                              ? () =>
                                                  handleDeleteSet(
                                                    mainindex,
                                                    index1,
                                                  )
                                              : () => {}
                                          }
                                        />
                                      </Tooltip>
                                    </div>
                                  )}
                              </div>
                            )}
                            {memberId &&
                            data.parameters.includes("Vdot") &&
                            (!item?.vdot || !member_vdot) ? (
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="start"
                                sx={{
                                  padding: data.parameters.includes("Vdot")
                                    ? "9px 0px"
                                    : "",
                                  overflowX: "auto",
                                  "&::-webkit-scrollbar": {
                                    height: "5px",
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#888",
                                    borderRadius: "5px",
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f1f1f1",
                                  },
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    opacity: 0.6,
                                    fontWeight: "600",
                                    fontSize: "12px",
                                  }}
                                >
                                  Auto Pacer is not calculated. Please{" "}
                                  <Link
                                    component={RouterLink}
                                    variant="subtitle2"
                                    to={`/member/edit-member/${memberId}`}
                                  >
                                    Click here
                                  </Link>{" "}
                                  to calculate it.
                                </Typography>
                              </Stack>
                            ) : (
                              <div
                                className="d-flex align-items-center w-100"
                                onMouseEnter={() =>
                                  handleMouseEnter(index1, mainindex)
                                }
                              >
                                {!data.parameters.includes("Vdot") && (
                                  <div className="d-flex align-items-center">
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        padding: "25px 4px",
                                        color: "inherit",
                                        backgroundColor: "#edeff1",
                                        height: "100%",
                                        width: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "7px",
                                      }}
                                    >
                                      {index1 + 1}
                                    </Typography>

                                    <CloseIcon sx={{ opacity: 0.3 }} />
                                  </div>
                                )}
                                <div className="row w-100">
                                  {data.parameters.includes("Vdot") && (
                                    <>
                                      {memberId && (
                                        <div
                                          className={
                                            isWithHistoryAndBigScreen
                                              ? "col-2 pe-0 py-1"
                                              : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                                          }
                                        >
                                          <TextField
                                            id="outlined-basic"
                                            size="small"
                                            variant="outlined"
                                            placeholder="0"
                                            type="number"
                                            onMouseLeave={() =>
                                              handleMouseEnter(
                                                index1,
                                                mainindex,
                                              )
                                            }
                                            onClick={() => handleMouseLeave()}
                                            label="Auto Pacer"
                                            value={item?.vdot || member_vdot}
                                            name="vdot"
                                            InputLabelProps={{
                                              className:
                                                "textfiels-input-label",
                                              shrink: true,
                                              style: { fontSize: "14px" },
                                            }}
                                            InputProps={{
                                              className:
                                                "textfiels-input-value",
                                              style: {
                                                fontSize: "13px",
                                                paddingLeft: "0px",
                                                paddingRight: "5px",
                                              },
                                              readOnly: true,
                                            }}
                                            sx={{
                                              borderRadius: "5px",
                                              fontSize: "13px",
                                              width: "100%",
                                              marginTop: "5px",
                                            }}
                                          />
                                        </div>
                                      )}
                                      <div
                                        className={
                                          isWithHistoryAndBigScreen
                                            ? "col-5 pe-0 py-1"
                                            : `col-12 col-md-5 ${
                                                isSidebar
                                                  ? "col-lg-4"
                                                  : "col-lg-3"
                                              } pe-0 py-1`
                                        }
                                      >
                                        <TextField
                                          id="outlined-basic"
                                          variant="outlined"
                                          label="Type"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingLeft: "0px",
                                              paddingRight: "0px",

                                              justifyContent: "center",
                                            },
                                            endAdornment: (
                                              <InputAdornment
                                                position="end"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="race_type"
                                                  value={item?.race_type}
                                                  label="Weight Type"
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeVdotDistance(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  <MenuItem value="el">
                                                    Easy/Long
                                                  </MenuItem>
                                                  <MenuItem value="c">
                                                    Compromised
                                                  </MenuItem>
                                                  <MenuItem value="t">
                                                    Threshold
                                                  </MenuItem>
                                                  <MenuItem value="i">
                                                    Interval
                                                  </MenuItem>
                                                  <MenuItem value="r">
                                                    Repitition
                                                  </MenuItem>
                                                </Select>
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="pace_type"
                                                  value={item?.pace_type}
                                                  label="Weight Type"
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeVdotPaceType(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  {item?.optionsType?.map(
                                                    (option) => {
                                                      return (
                                                        <MenuItem
                                                          key={option?.key}
                                                          value={option?.key}
                                                        >
                                                          {option?.title}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            marginTop: "5px",
                                            "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                              {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                            "& .css-1nuss9t": {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                            width: "100%",
                                          }}
                                        />
                                      </div>
                                      {memberId ? (
                                        item?.race_type == "el" ? (
                                          <div
                                            className={
                                              isWithHistoryAndBigScreen
                                                ? "col-3 pe-0 py-1"
                                                : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                                            }
                                          >
                                            <TextField
                                              id="outlined-basic"
                                              variant="outlined"
                                              label={getPaceText(
                                                item?.pace_type,
                                              )}
                                              InputLabelProps={{
                                                className:
                                                  "textfiels-input-label",
                                                shrink: true,
                                                style: { fontSize: "14px" },
                                              }}
                                              InputProps={{
                                                className:
                                                  "textfiels-input-value",
                                                style: {
                                                  fontSize: "13px",
                                                  paddingLeft: "0px",
                                                  paddingRight: "0px",
                                                  justifyContent: "center",
                                                },
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment
                                                    position="end"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <TextField
                                                      id="outlined-basic-minutes"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Min"
                                                      name="pace"
                                                      value={formatWithLeadingZeros(
                                                        Math.floor(
                                                          item?.pace / 60,
                                                        ),
                                                      )}
                                                      onChange={(e) =>
                                                        handleMinutesChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },
                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                      }}
                                                    />
                                                    <div className="fs-6 fw-semibold ms-1 ">
                                                      :
                                                    </div>
                                                    <TextField
                                                      id="outlined-basic-seconds"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Sec"
                                                      name="pace"
                                                      value={formatWithLeadingZeros(
                                                        item?.pace % 60,
                                                      )}
                                                      onChange={(e) =>
                                                        handleSecondsChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },
                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                      }}
                                                    />
                                                    <div className="fs-6 fw-semibold ms-1 me-1 ">
                                                      -
                                                    </div>
                                                    <TextField
                                                      id="outlined-basic-minutes"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Min"
                                                      name="paceUp"
                                                      value={formatWithLeadingZeros(
                                                        Math.floor(
                                                          item?.paceUp / 60,
                                                        ),
                                                      )}
                                                      onChange={(e) =>
                                                        handleMinutesChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },
                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                      }}
                                                    />
                                                    <div className="fs-6 fw-semibold ms-1">
                                                      :
                                                    </div>
                                                    <TextField
                                                      id="outlined-basic-seconds"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Sec"
                                                      name="paceUp"
                                                      value={formatWithLeadingZeros(
                                                        item?.paceUp % 60,
                                                      )}
                                                      onChange={(e) =>
                                                        handleSecondsChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },
                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                        marginRight: 1,
                                                      }}
                                                    />
                                                  </InputAdornment>
                                                ),
                                              }}
                                              sx={{
                                                borderRadius: "5px",
                                                fontSize: "13px",
                                                marginTop: "5px",
                                                "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                  {
                                                    width: "0px !important",
                                                    padding:
                                                      "9px 0px !important",
                                                  },
                                                "& .css-1nuss9t": {
                                                  width: "0px !important",
                                                  padding: "9px 0px !important",
                                                },
                                                width: "100%",
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <div
                                            className={
                                              isWithHistoryAndBigScreen
                                                ? "col-2 pe-0 py-1"
                                                : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                                            }
                                          >
                                            <TextField
                                              id="outlined-basic"
                                              variant="outlined"
                                              label={getPaceText(
                                                item?.pace_type,
                                              )}
                                              InputLabelProps={{
                                                className:
                                                  "textfiels-input-label",
                                                shrink: true,
                                                style: { fontSize: "14px" },
                                              }}
                                              InputProps={{
                                                className:
                                                  "textfiels-input-value",
                                                style: {
                                                  fontSize: "13px",
                                                  paddingLeft: "0px",
                                                  paddingRight: "0px",
                                                  justifyContent: "center",
                                                },
                                                readOnly: true,
                                                endAdornment: (
                                                  <InputAdornment
                                                    position="end"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <TextField
                                                      id="outlined-basic-minutes"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Min"
                                                      name="pace"
                                                      value={formatWithLeadingZeros(
                                                        Math.floor(
                                                          item?.pace / 60,
                                                        ),
                                                      )}
                                                      onChange={(e) =>
                                                        handleMinutesChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },

                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                      }}
                                                    />
                                                    <div className="fs-6 fw-semibold ms-1 ">
                                                      :
                                                    </div>
                                                    <TextField
                                                      id="outlined-basic-seconds"
                                                      type="number"
                                                      size="small"
                                                      placeholder="Sec"
                                                      name="pace"
                                                      value={formatWithLeadingZeros(
                                                        item?.pace % 60,
                                                      )}
                                                      onChange={(e) =>
                                                        handleSecondsChange(
                                                          e,
                                                          mainindex,
                                                          index1,
                                                        )
                                                      }
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                        readOnly: true,
                                                      }}
                                                      sx={{
                                                        "& fieldset": {
                                                          border: "none",
                                                        },
                                                        "& input": {
                                                          textAlign: "center",
                                                          padding: "0px",
                                                        },
                                                        width: "100%",
                                                      }}
                                                    />
                                                  </InputAdornment>
                                                ),
                                              }}
                                              sx={{
                                                borderRadius: "5px",
                                                fontSize: "13px",
                                                "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                  {
                                                    width: "0px !important",
                                                    padding:
                                                      "9px 0px !important",
                                                  },
                                                "& .css-1nuss9t": {
                                                  width: "0px !important",
                                                  padding: "9px 0px !important",
                                                },
                                                width: "100%",
                                                marginTop: "5px",
                                              }}
                                            />
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                  {data.parameters.includes("Pace") && (
                                    <>
                                      <div
                                        className={
                                          isWithHistoryAndBigScreen
                                            ? `${
                                                item?.race_type == "t"
                                                  ? "col-4 "
                                                  : "col-3"
                                              } pe-0 py-1`
                                            : `col-12 col-md-3 ${
                                                item?.race_type == "t"
                                                  ? "col-lg-3"
                                                  : "col-lg-2"
                                              }  pe-0 py-1`
                                        }
                                      >
                                        <FormControl fullWidth className="py-1">
                                          <InputLabel
                                            className="set-Type-lable"
                                            sx={{ fontSize: "14px" }}
                                            id="demo-simple-select-label"
                                          >
                                            Type
                                          </InputLabel>
                                          <Select
                                            className="set-Type-value"
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="race_type"
                                            value={item?.race_type}
                                            label="Type"
                                            inputProps={{
                                              style: {
                                                padding: 0,
                                              },
                                            }}
                                            onChange={(e) => {
                                              handleChangeVdotDistance(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            sx={{
                                              width: "100%",
                                              fontSize: "13px",
                                              "& .MuiOutlinedInput-input": {
                                                paddingLeft: 1,
                                              },
                                            }}
                                          >
                                            <MenuItem value="el">
                                              Easy/Long
                                            </MenuItem>
                                            <MenuItem value="c">
                                              Compromised
                                            </MenuItem>
                                            <MenuItem value="t">
                                              Threshold/Tempo
                                            </MenuItem>
                                            <MenuItem value="i">
                                              Interval
                                            </MenuItem>
                                            <MenuItem value="r">
                                              Repitition
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                      <div
                                        className={
                                          isWithHistoryAndBigScreen
                                            ? "col-3 pe-0 py-1"
                                            : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                                        }
                                      >
                                        <TextField
                                          sx={{
                                            borderRadius: "5px",
                                            paddingRight: 0,
                                            width: "100%",
                                            marginTop: "5px",
                                          }}
                                          size="small"
                                          id="custom-input"
                                          variant="outlined"
                                          onMouseLeave={() =>
                                            handleMouseEnter(index1, mainindex)
                                          }
                                          onClick={() => handleMouseLeave()}
                                          placeholder={"Distance"}
                                          name="distance"
                                          label="Distance"
                                          value={item?.distance}
                                          onChange={(e) => {
                                            handleChange(e, mainindex, index1);
                                          }}
                                          type="number"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="distanceType"
                                                  value={item?.distanceType}
                                                  label="Weight Type"
                                                  onChange={(e) => {
                                                    handleChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  onMouseLeave={() =>
                                                    handleMouseEnter(
                                                      index1,
                                                      mainindex,
                                                    )
                                                  }
                                                  onClick={() =>
                                                    handleMouseLeave()
                                                  }
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem value="m">
                                                    Meter
                                                  </MenuItem>
                                                  <MenuItem value="km">
                                                    KM
                                                  </MenuItem>
                                                  <MenuItem value="mi">
                                                    Mile
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={
                                          isWithHistoryAndBigScreen
                                            ? "col-3 pe-0 py-1"
                                            : `col-12 col-md-2 col-lg-2 pe-0 py-1`
                                        }
                                      >
                                        <TextField
                                          id="outlined-basic"
                                          variant="outlined"
                                          label={getPaceTextinPaces(
                                            item?.distanceType,
                                          )}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingLeft: "0px",
                                              paddingRight: "0px",

                                              justifyContent: "center",
                                            },
                                            readOnly: true,
                                            endAdornment: (
                                              <InputAdornment
                                                position="end"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <TextField
                                                  id="outlined-basic-minutes"
                                                  type="number"
                                                  size="small"
                                                  placeholder="Min"
                                                  name="pace"
                                                  value={formatWithLeadingZeros(
                                                    Math.floor(item?.pace / 60),
                                                  )}
                                                  onChange={(e) =>
                                                    handleMinutesChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    )
                                                  }
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  sx={{
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& input": {
                                                      textAlign: "center",
                                                      padding: "0px",
                                                    },
                                                    width: "100%",
                                                  }}
                                                />
                                                <div className="fs-6 fw-semibold ms-1 ">
                                                  :
                                                </div>
                                                <TextField
                                                  id="outlined-basic-seconds"
                                                  type="number"
                                                  size="small"
                                                  placeholder="Sec"
                                                  name="pace"
                                                  value={formatWithLeadingZeros(
                                                    item?.pace % 60,
                                                  )}
                                                  onChange={(e) =>
                                                    handleSecondsChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    )
                                                  }
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  sx={{
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& input": {
                                                      textAlign: "center",
                                                      padding: "0px",
                                                    },
                                                    width: "100%",
                                                  }}
                                                />
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                              {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                            "& .css-1nuss9t": {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                            width: "100%",
                                            marginTop: "5px",
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          position: "absolute",
                                          bottom: "4px",
                                          left: "52px",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            opacity: 0.6,
                                            fontWeight: "600",
                                            fontSize: "12px",
                                          }}
                                        >{` @ Speed ${getKmhrForPace(
                                          item?.distance,
                                          item?.pace,
                                          item?.distanceType,
                                        )} km/hr or ${getMihrForPace(
                                          item?.distance,
                                          item?.pace,
                                          item?.distanceType,
                                        )} mi/hr`}</Typography>
                                      </div>
                                    </>
                                  )}
                                  {data.parameters.includes("Distance") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                                      }
                                    >
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder={"Distance"}
                                        name="distance"
                                        label="Distance"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {(data.parameters.includes("Duration/Pace") ||
                                    data.parameters.includes("Time")) && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder="0"
                                        type="number"
                                        value={item?.time}
                                        name="time"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label={
                                          data.parameters.includes(
                                            "Duration/Pace",
                                          )
                                            ? "Duration/Pace"
                                            : "Time"
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="timeType"
                                                value={item?.timeType}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="sec">
                                                  sec
                                                </MenuItem>
                                                <MenuItem value="min">
                                                  min
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Reps") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Reps"
                                        type="text"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Reps"
                                        value={item?.reps}
                                        name="reps"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Max_Reps") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Max Reps"
                                        type="text"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Max Reps"
                                        value={item?.maxReps}
                                        name="maxReps"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Watts") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Watts"
                                        type="number"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Watts"
                                        value={item?.watts}
                                        name="watts"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Height") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : "col-12 col-md-3 col-lg-2 pe-0 py-2"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.height}
                                        name="height"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: {
                                            fontSize: "14px",
                                          },
                                        }}
                                        label="Height"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="height_unit"
                                                value={item?.height_unit}
                                                label="Height Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="cm">
                                                  Cm
                                                </MenuItem>
                                                <MenuItem value="ft">
                                                  Feet
                                                </MenuItem>
                                                <MenuItem value="inch">
                                                  Inch
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Weight") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : "col-12 col-md-4 col-lg-2 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder="Weight"
                                        name="weight"
                                        label="Weight"
                                        value={item.weight}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="weightType"
                                                value={item?.weightType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="1rm">
                                                  % 1RM
                                                </MenuItem>
                                                <MenuItem value="body_weight">
                                                  % BW
                                                </MenuItem>
                                                <MenuItem value="kg">
                                                  KG
                                                </MenuItem>
                                                <MenuItem value="lb">
                                                  Pound
                                                </MenuItem>
                                                <MenuItem value="poods">
                                                  Poods
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes(
                                    "Distance/Calories",
                                  ) && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : "col-12 col-md-3 col-lg-2 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder={
                                          item?.distanceType == "calories"
                                            ? "Calories"
                                            : "Distance"
                                        }
                                        name="distance"
                                        label="Distance/Calories"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                                <MenuItem value="calories">
                                                  Calories
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("%MHR") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="%MHR"
                                        type="number"
                                        label="%MHR"
                                        value={item?.mhr}
                                        name="mhr"
                                        onChange={(e) => {
                                          handleChangeTempo(
                                            e,
                                            mainindex,
                                            index1,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("RPE") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="RPE"
                                        label="RPE"
                                        value={item?.RPE}
                                        name="RPE"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Tempo") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-2 pe-0 py-1"
                                          : "col-12 col-md-2 col-lg-1 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Tempo"
                                        type="number"
                                        label="Tempo"
                                        value={item?.tempo}
                                        name="tempo"
                                        onChange={(e) => {
                                          handleChangeTempo(
                                            e,
                                            mainindex,
                                            index1,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Rest") && (
                                    <div
                                      className={
                                        isWithHistoryAndBigScreen
                                          ? "col-3 pe-0 py-1"
                                          : "col-12 col-md-3 col-lg-2 pe-0 py-1"
                                      }
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.rest}
                                        name="rest"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label="Rest"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="restType"
                                                value={item?.restType}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="sec">
                                                  sec
                                                </MenuItem>
                                                <MenuItem value="min">
                                                  min
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          marginTop: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {memberId &&
                                    data.parameters.includes("Vdot") && (
                                      <div>
                                        {item?.race_type == "el" ? (
                                          <Typography
                                            variant="subtitle2"
                                            sx={{
                                              opacity: 0.6,
                                              fontWeight: "600",
                                              fontSize: "12px",
                                            }}
                                          >{` @ Speed ${getKmhr(
                                            item?.pace,
                                            item?.pace_type,
                                          )} km/hr or ${getMihr(
                                            item?.pace,
                                            item?.pace_type,
                                          )} mi/hr -  ${getKmhr(
                                            item?.paceUp,
                                            item?.pace_type,
                                          )} km/hr or ${getMihr(
                                            item?.paceUp,
                                            item?.pace_type,
                                          )} mi/hr`}</Typography>
                                        ) : (
                                          <Typography
                                            variant="subtitle2"
                                            sx={{
                                              opacity: 0.6,
                                              fontWeight: "600",
                                              fontSize: "12px",
                                            }}
                                          >{` @ Speed ${getKmhr(
                                            item?.pace,
                                            item?.pace_type,
                                          )} km/hr or ${getMihr(
                                            item?.pace,
                                            item?.pace_type,
                                          )} mi/hr`}</Typography>
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}

                      {data?.open && (
                        <div className="row mt-3 d-flex justify-content-center">
                          <div className="col-md-2 col-lg-1 col-3">
                            <button
                              onClick={(e) => {
                                e.preventDefault();

                                handleArrow(false, mainindex);
                              }}
                              className="w-100 small-contained-set-button"
                            >
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  opacity: 0.5,
                                  fontSize: "20px",
                                }}
                                onClick={() => {
                                  handleArrow(false, mainindex);
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      )}
                    </Box>
                  </div>
                  <span
                    className="cross-icon"
                    style={{
                      position: "absolute",
                      bottom: "-12px",
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      zIndex: 1,
                    }}
                  >
                    {addArray.length > 1 &&
                    mainindex < addArray.length - 1 &&
                    addArray[mainindex + 1]?.type == "general" ? (
                      <div className="">
                        <SyncIcon
                          onClick={() => handleAgreeExercise(mainindex)}
                          className="sync-icon-add"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};
export default WorkoutExercisesUI;
